<template>
  <div class="position-relative">
    <div class="fileUpload" @click.stop="toggleDrop()">
      <img v-if="!image" src="@/assets/images/oval.png" alt="image" />
      <img v-if="image" :src="image" alt="image" class="w-100" height="60px" />
    </div>
    <div class="file__upload__dropdown" v-click-outside="dropClose" v-show="openDropdown">
      <label class="txt--ss cursor-pointer mb-3">
        <input type="file" @change="loadTextFromFile" />
        Upload Photo
      </label>
      <label class="txt--ss cursor-pointer mb-0" @click="showSteetView">Street View</label>
      <label
        class="txt--ss cursor-pointer mt-3 mb-0"
        @click="viewPropertyImage()"
        v-if="image"
      >View Image</label>
      <label
        class="txt--ss cursor-pointer mt-3 mb-0"
        v-if="image"
        @click="confirmDelete()"
      >Delete</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "imageUpload",
  props: ["property_image", "index"],
  data() {
    return {
      image: this.property_image,
      openDropdown: false
    };
  },
  directives: {
    "click-outside": {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
        console.log(binding);
      }
    }
  },
  created() {
    window.EventBus.$on("image_drop_open", data => {
      if (data != this.index) {
        this.openDropdown = false;
      }
    });
    if(this.property_image instanceof File)
    {
      this.image = URL.createObjectURL(this.property_image);
    }
  },
  methods: {
    viewPropertyImage() {
      this.$emit("image_to_view", this.index);
    },
    toggleDrop() {
      this.openDropdown = !this.openDropdown;
      window.EventBus.$emit("image_drop_open", this.index);
    },
    showSteetView() {
      this.openDropdown = false;
      this.$emit("streetViewcomp", {
        show_street: true,
        index: this.index
      });
    },
    dropClose() {
      this.openDropdown = false;
    },
    loadTextFromFile(e) {
      this.openDropdown = false ;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.image = "";
        return;
      }
      
      if (files[0].name.substring(files[0].name.lastIndexOf('.') + 1)=='jfif'){
         this.$toasted.show("This file format is not allowed!", {
            icon: "times-circle",
            className: "error-class",
          });
          return;
      }
      if (files[0].type != "" && files[0].type.indexOf("image/") != -1) {
        //======= Check Size ============//
        if (files[0].size > 2097152) {
          this.$toasted.show("Please upload an image file below 2MB!", {
            icon: "times-circle",
            className: "error-class",
          });
          return;
        }
        this.createImage(files[0]);
        this.$emit("change:image", files[0]);
      } else {
        this.$toasted.show("Only Images are allowed!", {
          icon: "times-circle",
          className: "error-class"
        });
      }
    },
    createImage(file) {
      var reader = new FileReader();
      reader.onload = e => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    confirmDelete() {
      const self = this;
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete this image?",
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          self.$emit("delete_image", self.index);
        }
      });
    }
  }
};
</script>

<style>
.fileUpload {
  width: 90px;
  height: 60px;
  background-color: #121212;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.file__upload__dropdown {
  background-color: #191919;
  padding: 25px;
  border-radius: 6px;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 20px;
  left: 20px;
  min-width: 140px;
  z-index: 2;
}
.file__upload__dropdown__label {
  cursor: pointer;
}
/* .fileUpload__label {
  cursor: pointer;
  margin-bottom: 0;
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
} */
input[type="file"] {
  display: none;
}
</style>